import { render, staticRenderFns } from "./documentOptions.vue?vue&type=template&id=85211dea"
import script from "./documentOptions.vue?vue&type=script&lang=js"
export * from "./documentOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports